import { render } from "./ConfirmarModal.vue?vue&type=template&id=11bc90fa"
import script from "./ConfirmarModal.vue?vue&type=script&lang=js"
export * from "./ConfirmarModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__